/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown> }} Automation_Action_LabelInputs */

const en_automation_action_label = /** @type {(inputs: Automation_Action_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.action === "createTask") return /** @type {LocalizedString} */ (`Create task`);
	if (i?.action === "moveCase") return /** @type {LocalizedString} */ (`Move case`);
	if (i?.action === "resolveException") return /** @type {LocalizedString} */ (`Resolve case exception`);
	if (i?.action === "assignTask") return /** @type {LocalizedString} */ (`Assign task`);
	if (i?.action === "startAnalysis") return /** @type {LocalizedString} */ (`Start AI analysis`);
	if (i?.action === "notify") return /** @type {LocalizedString} */ (`Send notifications`);
	if (i?.action === "emailAssignee") return /** @type {LocalizedString} */ (`Email the assignee`);
	return /** @type {LocalizedString} */ (`${i?.action}`)
	
};

const pt_br2_automation_action_label = /** @type {(inputs: Automation_Action_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.action === "createTask") return /** @type {LocalizedString} */ (`Criar tarefa`);
	if (i?.action === "moveCase") return /** @type {LocalizedString} */ (`Mover caso`);
	if (i?.action === "resolveException") return /** @type {LocalizedString} */ (`Resolver exceção do caso`);
	if (i?.action === "assignTask") return /** @type {LocalizedString} */ (`Atribuir tarefa`);
	if (i?.action === "startAnalysis") return /** @type {LocalizedString} */ (`Iniciar análise por IA`);
	if (i?.action === "notify") return /** @type {LocalizedString} */ (`Enviar notificações`);
	if (i?.action === "emailAssignee") return /** @type {LocalizedString} */ (`Enviar e-mail ao responsável`);
	return /** @type {LocalizedString} */ (`${i?.action}`)
	
};

/**
* | action | output |
* | --- | --- |
* | "createTask" | "Create task" |
* | "moveCase" | "Move case" |
* | "resolveException" | "Resolve case exception" |
* | "assignTask" | "Assign task" |
* | "startAnalysis" | "Start AI analysis" |
* | "notify" | "Send notifications" |
* | "emailAssignee" | "Email the assignee" |
* | * | "{action}" |
*
* @param {Automation_Action_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_action_label = /** @type {((inputs: Automation_Action_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Action_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_action_label(inputs)
	return pt_br2_automation_action_label(inputs)
});